import ThemedModal from "components/atoms/ThemedModal";
import i18n from "utils/i18n";
import Text from "theme/Text";
import Button from "theme/Button";
import { useRef, useState } from "react";
import InputPlusMin from "components/molecules/InputPlusMin";
import VStack from "components/atoms/stack/VStack";
import useMutate from "utils/hooks/useMutate";
import MutationManagementCreditsChange from "graphql/mutations/management/MutationManagementCreditsChange";

const CreditManageModal = ({ employee, item, onClose, onConfirm, loading }) => {

    const [ amount, setAmount ] = useState( item?.amount_unused || 0 );

	const [ mutateCreditsChange, { loading: transactionLoading, error: transactionError, data: transactionData } ] = useMutate( MutationManagementCreditsChange );

    const onPressConfirm = async () => {
        await mutateCreditsChange({
            variables: {
                employee_guid: employee?.guid,
                timeslot_kind_guid: item?.timeslot_kind?.guid,
                amount: amount
            },
            onSuccess: ( data ) => {
                if( onConfirm ) {
                    onConfirm();
                }
            }
        });
    }

    return (
        <ThemedModal
            visible={ true }
            setVisible={ onClose }
            title={ i18n.t( 'management:pages.employee.credits.button_add_remove' ) }
            footer={(
                <>
                    <Button
                        appearance="ghost"
                        onPress={ onClose }>
                        
                        { i18n.t('management:modal.basic.cancel' ) }
                    </Button>
                    
                    <Button
                        isLoading={ loading }
                        onPress={ onPressConfirm }>
                        
                        { i18n.t('basic.save') }
                    </Button>
                </>
            )}>
            
            <VStack>
                <Text>{ i18n.t('management:modal.credit_management.text') }</Text>

                <InputPlusMin 
                    value={ amount }
                    onChange={ setAmount }
                />
            </VStack>
        </ThemedModal>
    )
}

export default CreditManageModal;